import * as actionTypes from "./index";
import {actionCreator} from "../helpers/functions";

export const changeEditingSettings = actionCreator(actionTypes.CHANGE_EDITING_SETTINGS);

export const updateEditingSettings = actionCreator(actionTypes.UPDATE_EDITING_SETTINGS);
export const updateEditingSettingsSuccess = actionCreator(actionTypes.UPDATE_EDITING_SETTINGS_SUCCESS);
export const updateEditingSettingsFailed = actionCreator(actionTypes.UPDATE_EDITING_SETTINGS_FAILED);

export const fetchEditingSettings = actionCreator(actionTypes.FETCH_EDITING_SETTINGS);
export const fetchEditingSettingsSuccess = actionCreator(actionTypes.FETCH_EDITING_SETTINGS_SUCCESS);
export const fetchEditingSettingsFailed = actionCreator(actionTypes.FETCH_EDITING_SETTINGS_FAILED);

export const fetchEditingSettingsEditableByOptions = actionCreator(actionTypes.FETCH_EDITING_SETTING_EDITABLE_BY_OPTIONS);
export const fetchEditingSettingsEditableByOptionsSuccess = actionCreator(actionTypes.FETCH_EDITING_SETTING_EDITABLE_BY_OPTIONS_SUCCESS);
export const fetchEditingSettingsEditableByOptionsFailed = actionCreator(actionTypes.FETCH_EDITING_SETTING_EDITABLE_BY_OPTIONS_FAILED);